import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import App from './App.vue';
import { useAuthStore } from '@/stores/auth';
import { useExecutionRealtimeStore } from '@/stores/executionRealtime';
import './assets/main.css';

const app = createApp(App);

// Global error handler
app.config.errorHandler = (err, _instance, info) => {
  console.error('Global error:', err);
  console.error('Error info:', info);
  
  // In production, you might want to send this to an error tracking service
  if (import.meta.env.PROD) {
    // TODO: Send to error tracking service (e.g., Sentry)
  }
};

// Global warning handler (development only)
if (import.meta.env.DEV) {
  app.config.warnHandler = (msg, _instance, trace) => {
    console.warn('Warning:', msg);
    console.warn('Trace:', trace);
  };
}

const pinia = createPinia();
app.use(pinia);
// Hydrate session before the first navigation so deep links survive a full reload.
const authStore = useAuthStore();
authStore.restoreAuth();
authStore.$subscribe((_mutation, state) => {
  if (!state.token) {
    useExecutionRealtimeStore().disconnect();
  }
});
app.use(router);

// Initialize theme store so it syncs with DOM (index.html script already set class to avoid flash)
import { useThemeStore } from '@/stores/theme';
useThemeStore();

app.mount('#app');
